import React from 'react';
import card0 from '../../../assets/images/tarotcards/tarot-card-0.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';


class Card0 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }


    render() {
    return (
        <div>
            <div style={{
                margin: '25px', color: '#e0515d', marginTop: '100px',
                fontSize: '45px', fontFamily: 'balthazar,serif',
                fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'
            }}>
                <FormattedMessage id="dailylove.title"
                    defaultMessage="Free Daily Love Tarot Reading"
                />
            </div>
            <div style={{ padding: '40px' }}>
                <h2 style={{
                    fontFamily: 'khand,sans-serif',
                    fontSize: '2rem',
                    fontWeight: '100',
                    letterSpacing: '.02em',
                    textTransform: 'uppercase', textAlign: 'center'
                }}>
                    <FormattedMessage id="t01"
                        defaultMessage="THE FOOL:"
                    />
                </h2>
                <img src={card0} style={{ marginLeft: '9%', float: 'left', padding: '20px' }} />

                <p style={{
                    fontSize: '2rem', color: '#fefefe',
                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%', fontWeight: '400'
                }}>
                    <br></br>
                    <FormattedMessage id="t02"
                        defaultMessage="You're learning, but you're just not quite there yet. The Fool signifies inexperience and,of course, a certain amount of foolishness when it comes to love. Even if you've been around the block a time or two, there is still plenty for you to learn. Don't be fearful of what love has in store for you, but keep your eyes open for roadblocks along the way and try not to stumble over them."
                    />
                    <br></br><br></br>
                </p>
            </div>
            <div style={{ display: 'flex', paddingBottom: '50px' }}>
                <span style={{ width: '33%' }}>
                </span>
                <span style={{ width: '33%' }}>
                    <Link to="/dailyLove">
                        <button style={{ lineHeight: '2', letterSpacing: '0.02em' }} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                            defaultMessage="PICK ANOTHER CARD"
                        /></strong></button>
                    </Link>
                </span>
                <span style={{ width: '34%' }}>
                </span>
            </div>
                        
        </div>
        )
    }
}

export default Card0;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard0.js